<template>
  <nav
    v-show="visibleItems.length"
    class="min-w-0 text-xs font-medium"
    :aria-label="ariaLabel"
    :aria-hidden="visibleItems.length ? undefined : 'true'"
  >
    <ol class="flex min-w-0 flex-wrap items-center gap-x-1.5 gap-y-1">
      <li
        v-for="(item, index) in visibleItems"
        :key="`${item.label}-${index}`"
        class="inline-flex min-w-0 items-center gap-1.5"
      >
        <router-link
          v-if="isNavigable(item)"
          :to="item.to"
          class="min-w-0 truncate text-theme-text-secondary transition-colors hover:text-theme-palette-emerald dark:hover:text-theme-palette-emerald"
        >
          {{ item.label }}
        </router-link>
        <span
          v-else
          class="min-w-0 truncate text-theme-text-muted"
          :aria-current="item.current ? 'page' : undefined"
        >
          {{ item.label }}
        </span>
        <icon
          v-if="index < visibleItems.length - 1"
          :path="mdiChevronRight"
          size="13"
          class="shrink-0 text-theme-text-muted"
          aria-hidden="true"
        />
      </li>
    </ol>
  </nav>
</template>

<script setup>
  /* eslint-disable no-undef */
  import Icon from '@/components/Icon';
  import { mdiChevronRight } from '@mdi/js';
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  const props = defineProps({
    items: { type: Array, default: () => [] },
    ariaLabel: { type: String, default: '' },
  });

  const { t } = useI18n();

  const ariaLabel = computed(() => props.ariaLabel || t('ui.breadcrumbs', 'Breadcrumbs'));

  const visibleItems = computed(() =>
    (props.items || [])
      .map((item) => ({
        ...item,
        label: item?.label == null ? '' : String(item.label).trim(),
      }))
      .filter((item) => item.label)
  );

  function isPlaceholderTarget(to) {
    if (!to || to === '#') return true;
    if (typeof to === 'string') return to.includes(':');
    if (typeof to.path === 'string') return to.path.includes(':');
    return false;
  }

  function isNavigable(item) {
    return item?.to && item.current !== true && !isPlaceholderTarget(item.to);
  }
</script>
